(() => {
  'use strict';
  if (window.__phProductLabels) return;
  window.__phProductLabels = true;
  let countBusy = false;
  let nextCountRefresh = Date.now() + 43200000;
  let shippingBusy = false;
  let shippingTimer;
  const shippingCache = new Map();
  async function shippingLabels() {
    if (shippingBusy || document.hidden) return;
    const labels = [...document.querySelectorAll('[data-ph-free-shipping]')];
    const pending = new Map();
    for (const label of labels) {
      const key = [label.dataset.country, label.dataset.variantId, label.dataset.price].join(':');
      const hit = shippingCache.get(key);
      if (hit && hit.until > Date.now()) { label.hidden = !hit.free; continue; }
      label.hidden = true;
      if (!pending.has(label.dataset.country)) pending.set(label.dataset.country, new Map());
      pending.get(label.dataset.country).set(label.dataset.variantId, label.dataset.price);
    }
    shippingBusy = true;
    try {
      for (const [country, variants] of pending) {
        const rows = [...variants];
        for (let i = 0; i < rows.length; i += 8) {
          const batch = rows.slice(i, i + 8);
          const url = new URL('https://sync.prohaar.nl/product-delivery-labels.php');
          url.searchParams.set('country', country);
          url.searchParams.set('items', batch.map(([id, price]) => `${id}:${price}`).join(','));
          const response = await fetch(url, {credentials: 'omit', signal: AbortSignal.timeout(65000)});
          if (!response.ok) continue;
          const data = await response.json();
          for (const [id, price] of batch) {
            const key = [country, id, price].join(':');
            const free = data.items?.[id] === true;
            shippingCache.set(key, {free, until: Date.now() + 60000});
            for (const label of document.querySelectorAll('[data-ph-free-shipping]')) {
              if ([label.dataset.country, label.dataset.variantId, label.dataset.price].join(':') === key) label.hidden = !free;
            }
          }
        }
      }
    } catch (_) { /* A missing quote leaves the label hidden. */ }
    finally { shippingBusy = false; }
  }
  function refreshShipping() { clearTimeout(shippingTimer); shippingTimer = setTimeout(shippingLabels, 100); }
  async function monthlyCounts(force = false) {
    if (document.hidden || countBusy || (force !== true && Date.now() < nextCountRefresh)) return;
    const banners = [...document.querySelectorAll('[data-ph-monthly-section]')];
    if (!banners.length) return;
    countBusy = true;
    nextCountRefresh = Date.now() + 43200000;
    try {
      for (const banner of banners) {
        const id = banner.dataset.phMonthlySection;
        const target = banner.querySelector('[data-ph-monthly-count]');
        if (!target) continue;
        let count = 0;
        let pages = 1;
        const param = target.dataset.phMonthlyPageParam || 'page';
        for (let page = 1; page <= pages; page++) {
          const url = new URL(location.pathname, location.origin);
          url.searchParams.set('sections', id);
          url.searchParams.set(param, String(page));
          const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store'});
          if (!response.ok) throw new Error('Section unavailable');
          const html = (await response.json())[id];
          if (typeof html !== 'string') throw new Error('Section unavailable');
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-ph-monthly-count]');
          if (!fresh) { count = 0; break; }
          const n = Number(fresh.dataset.phMonthlyCount);
          if (!Number.isInteger(n) || n < 0) throw new Error('Count unavailable');
          count += n;
          if (page === 1) pages = Math.max(1, Number(fresh.dataset.phMonthlyPages) || 1);
        }
        target.querySelector('[data-ph-monthly-number]').textContent = String(count);
        target.hidden = false;
        banner.hidden = count === 0;
      }
    } catch (_) { /* Preserve the last server-rendered count on a temporary failure. */ }
    finally { countBusy = false; }
  }
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { monthlyCounts(); refreshShipping(); } });
  document.addEventListener('shopify:section:load', monthlyCounts);
  ['themeVariantUpdated', 'shopify:section:load', 'phCartRecommendationsLoaded'].forEach(name => { document.addEventListener(name, refreshShipping); window.addEventListener(name, refreshShipping); });
  new MutationObserver(records => { if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches('[data-ph-free-shipping]') || n.querySelector('[data-ph-free-shipping]'))))) refreshShipping(); }).observe(document.body, {childList: true, subtree: true});
  refreshShipping();
  setInterval(monthlyCounts, 43200000);
  if (document.querySelector('[data-ph-monthly-pages]:not([data-ph-monthly-pages="1"])')) monthlyCounts(true);
})();
